export const hasAuthToken = (token) =>
  Boolean(token && token !== "undefined");

export const authHeaders = (token) =>
  hasAuthToken(token) ? { Authorization: `Bearer ${token}` } : {};
